exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reservation-text{max-width:600px;display:flex;flex-direction:column;text-align:center;margin:50px auto 37px}@media (min-width:1024px){.reservation-text{margin-top:80px}}.reservation-text .code{margin-top:1.87rem;font-family:Avenir-Heavy;font-size:20px}.reservation-text .code .turquoiseBlue{color:#00adbc}.forms-container{max-width:875px;width:100%;display:flex;flex-direction:column;align-items:center}.forms-container .save-reservation-btn{margin:2rem auto}.boarding-container{display:flex}@media (max-width:992px){.boarding-container{flex-direction:column;align-items:center}}.boarding-container .boarding-pass{display:flex;flex-direction:column;margin:1rem;align-items:center}.boarding-container .boarding-pass .pdf-image{max-width:70px;width:100%;margin:.5rem}.boarding-container .boarding-pass .download-pdf{display:flex;color:#0fc0cc;font-size:1.125rem;align-items:center}.boarding-container .boarding-pass .download-pdf:hover{color:#06676e}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};